import { alpha } from '@mui/material/styles';
import { gray, orange, red, green, brand } from '../themePrimitives';

export const feedbackCustomizations = {
  MuiAlert: {
    styleOverrides: {
      root: ({ theme, ownerState }) => {
        let backgroundColor = orange[100];
        let borderColor = alpha(orange[300], 0.5);
        let iconColor = orange[500];

        switch (ownerState.severity) {
          case 'error':
            backgroundColor = red[100];
            borderColor = alpha(red[300], 0.5);
            iconColor = red[500];
            break;
          case 'warning':
            backgroundColor = orange[100];
            borderColor = alpha(orange[300], 0.5);
            iconColor = orange[500];
            break;
          case 'info':
            backgroundColor = brand[100];
            borderColor = alpha(brand[300], 0.5);
            iconColor = brand[500];
            break;
          case 'success':
            backgroundColor = green[100];
            borderColor = alpha(green[300], 0.5);
            iconColor = green[500];
            break;
          default:
            break;
        }

        return {
          borderRadius: 10,
          backgroundColor: backgroundColor,
          color: (theme.vars || theme).palette.text.primary,
          border: `1px solid ${borderColor}`,
          '& .MuiAlert-icon': {
            color: iconColor,
          },
          ...theme.applyStyles('dark', {
            backgroundColor: alpha(backgroundColor, 0.5),
            border: `1px solid ${alpha(borderColor, 0.5)}`,
          }),
        };
      },
    },
  },
  MuiDialog: {
    styleOverrides: {
      root: ({ theme }) => ({
        '& .MuiDialog-paper': {
          borderRadius: '10px',
          border: '1px solid',
          borderColor: (theme.vars || theme).palette.divider,
        },
      }),
    },
  },
  MuiLinearProgress: {
    styleOverrides: {
      root: ({ theme }) => ({
        height: 8,
        borderRadius: 8,
        backgroundColor: gray[200],
        ...theme.applyStyles('dark', {
          backgroundColor: gray[800],
        }),
      }),
    },
  },
};
